import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { Names } from '@ils/static/names.js';
import { ExamSlotRating } from './slotRating.js';

@Entity()
export class ExamSlotFinalRating extends ExamSlotRating {
  static override _class = Names.ExamSlotFinalRating._class;

  constructor(doc: PartialEntityData<ExamSlotFinalRating>) {
    super(doc);
  }

  @Field(type => Int) voteDoctor?: number;
  @Field(type => Int) voteLinguist?: number;
}
